/* MIELLE_CART_BADGE_SYNC_20260817 */
(() => {
  'use strict';
  if (window.MielleCartBadgeSync) {
    window.MielleCartBadgeSync.sync();
    return;
  }

  const cartPathPattern = /\/cart\/(add|change|update|clear)\.js(?:\?|$)/;
  let syncTimer = 0;
  let activeSync = null;

  const render = (rawCount) => {
    const itemCount = Math.max(0, Number.parseInt(String(rawCount), 10) || 0);
    document.querySelectorAll('cart-icon').forEach((icon) => {
      const count = icon.querySelector('[ref="cartBubbleCount"]');
      const bubble = icon.querySelector('[ref="cartBubble"]');
      if (!count || !bubble) return;
      count.textContent = itemCount < 100 ? String(itemCount) : '';
      count.classList.toggle('hidden', itemCount === 0);
      bubble.classList.toggle('visually-hidden', itemCount === 0);
      icon.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
    });
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({
        value: String(itemCount),
        timestamp: Date.now()
      }));
    } catch (_) {}
    document.documentElement.dataset.cartItemCount = String(itemCount);
    return itemCount;
  };

  const sync = () => {
    if (activeSync) return activeSync;
    const root = window.Shopify?.routes?.root || '/';
    activeSync = window.fetch(`${root}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart sync failed: ${response.status}`);
        return response.json();
      })
      .then((cart) => render(cart.item_count))
      .catch(() => null)
      .finally(() => { activeSync = null; });
    return activeSync;
  };

  const schedule = (delay = 0) => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, delay);
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    try {
      const request = args[0];
      const inputUrl = typeof request === 'string' ? request : request?.url || '';
      const url = new URL(inputUrl, window.location.href);
      const initMethod = args[1]?.method;
      const requestMethod = typeof request === 'object' ? request?.method : '';
      const method = String(initMethod || requestMethod || 'GET').toUpperCase();
      if (response.ok && method !== 'GET' && cartPathPattern.test(url.pathname)) {
        schedule(0);
        window.setTimeout(sync, 450);
      }
    } catch (_) {}
    return response;
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    schedule(0);
    Promise.resolve(event.promise).then(sync, () => schedule(350));
  }, true);
  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') sync();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }

  window.MielleCartBadgeSync = { sync, render };
})();
